export default __webpack_public_path__ + "static/media/Corona.e79af983.png";